import { render } from "./DocumentGridView.vue?vue&type=template&id=f36854a0&scoped=true"
import script from "./DocumentGridView.vue?vue&type=script&lang=js"
export * from "./DocumentGridView.vue?vue&type=script&lang=js"

import "./DocumentGridView.vue?vue&type=style&index=0&id=f36854a0&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36854a0"]])

export default __exports__